import { render, staticRenderFns } from "./OrderHistoryList.vue?vue&type=template&id=0783f0eb&scoped=true&"
import script from "./OrderHistoryList.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryList.vue?vue&type=style&index=0&id=0783f0eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0783f0eb",
  null
  
)

export default component.exports